module.exports = __webpack_public_path__ + "media/images/flags/kh-66413c8d34570831ab7f342dcb7f25b4.svg";